import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import IntroPage from "@/components/IntroPage/IntroPage";
import DownloadPage from "@/components/DownloadPage/DownloadPage";
import NotFoundPage from "@/components/NotFoundPage/NotFoundPage";

// 路由配置
const router = createBrowserRouter([
  {
    path: "/",
    element: <IntroPage />,
  },
  {
    path: "/download",
    element: <DownloadPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

// 路由提供者组件
export const AppRouter: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default router;
